import * as React from 'react'
import { NavItem } from './core/ui/shell-header'
import EditableTooltip from 'src/components/editable-tooltip/tooltip'
import HttpService from './core/services/http.service'

export function getSideMenu(t: (value: string) => string, screenWidth: number): React.ReactNode[] {
  return [
  ]
}

export function getTopMainMenu(t: (value: string) => string, screenWidth: number): React.ReactNode[] {
  return []
}

export function getTopRightMenu(roles: string[], onMenuClick: any, language: string) {


  let isAdmin = roles.filter(o => o.includes("Administrator") || o.includes("Manager") || o.includes("ClientAdmin") || o.includes("FIConsultant") || o.includes("Contributor")).length > 0

  return (t: (value: string) => string, screenWidth: number): React.ReactNode[] => {
    const isTabletAndMobile = screenWidth < 768
    var menu = []
    if (isAdmin) {
    
      menu.push(<div data-tut="reactour__config" style={{ position: 'relative', width: 100, right: -100, zIndex: -10 }}></div>)
      menu.push(<div onClick={(p) => onMenuClick({ key: "hangfire" })} style={{ lineHeight: "56px" }}><NavItem key="/hangfire" icon="fire" title={t('Hangfire')} /></div>)
      menu.push(<div style={{ lineHeight: "56px" }}><EditableTooltip name="principal-config"><NavItem key="/time-tracking/admin" to="/time-tracking/admin" icon="setting" title={t('Settings')} /></EditableTooltip></div>)

    }
    else {
      menu.push(<div style={{ lineHeight: "56px" }} onClick={(p) => onMenuClick({ key: "notification" })}><NavItem icon="bell" title={t('Notifications')} /></div>)
    }
    if (language == 'fr')
      menu.push(<div style={{ lineHeight: "56px" }}><NavItem key="/time-tracking/guide" to="/time-tracking/guide" icon="solution" title={t('User guide / FAQ')} /></div>)


    menu.push(<div style={{ lineHeight: "56px" }} onClick={(p) => onMenuClick({ key: "whatsnew" })} ><NavItem icon="question-circle" title={t('What\'s New')} /></div>)
    return menu
  }
}